import { render, staticRenderFns } from "./trans_uniform.vue?vue&type=template&id=12e2090e&scoped=true"
import script from "./trans_uniform.vue?vue&type=script&lang=js"
export * from "./trans_uniform.vue?vue&type=script&lang=js"
import style0 from "./trans_uniform.vue?vue&type=style&index=0&id=12e2090e&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e2090e",
  null
  
)

export default component.exports